import React from 'react';
import { HomeIcon, UsersIcon, BuildingIcon, StarIcon, CheckIcon, LockIcon, BriefcaseIcon, TrophyIcon } from '../Icons/Icons';
import './TrustedPlatform.css';

function TrustedPlatform() {
  const stats = [
    {
      id: 1,
      number: '150,000+',
      label: 'Active Listings',
      icon: <HomeIcon size={48} color="var(--color-primary)" />
    },
    {
      id: 2,
      number: '2.5M+',
      label: 'Happy Users',
      icon: <UsersIcon size={48} color="var(--color-primary)" />
    },
    {
      id: 3,
      number: '50+',
      label: 'Cities Covered',
      icon: <BuildingIcon size={48} color="var(--color-primary)" />
    },
    {
      id: 4,
      number: '15+',
      label: 'Years of Trust',
      icon: <StarIcon size={48} color="var(--color-primary)" filled={true} />
    }
  ];

  return (
    <section className="trusted-platform">
      <div className="container">
        <div className="section-header">
          <h2>Pakistan's Most Trusted Property Platform</h2>
          <p>Connecting millions of buyers and sellers across the nation</p>
        </div>

        <div className="stats-grid">
          {stats.map(stat => (
            <div key={stat.id} className="stat-card">
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="trust-badges">
          <div className="badge">
            <span className="badge-icon">
              <CheckIcon size={20} color="var(--color-primary)" />
            </span>
            <span>Verified Listings</span>
          </div>
          <div className="badge">
            <span className="badge-icon">
              <LockIcon size={20} color="var(--color-primary)" />
            </span>
            <span>Secure Platform</span>
          </div>
          <div className="badge">
            <span className="badge-icon">
              <BriefcaseIcon size={20} color="var(--color-primary)" />
            </span>
            <span>Professional Agents</span>
          </div>
          <div className="badge">
            <span className="badge-icon">
              <TrophyIcon size={20} color="var(--color-primary)" />
            </span>
            <span>Accurate Pricing</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustedPlatform;
